import { patchRequest } from "./patchApi";
import { getPosts } from "./postsApi";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    posts: [],
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const fetchPosts = createAsyncThunk("posts/fetch", async (argument) => {
    const posts = await getPosts(argument);
    return posts;
});

export const patchPost = createAsyncThunk("posts/patch", async ({id, data}) => {
    const posts = await patchRequest({id, data});
    return posts;
});

const postsSlice = createSlice({
    name: "posts",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchPosts.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchPosts.fulfilled, (state, action) => {
                state.isLoading = false;
                state.posts = action.payload;
            })
            .addCase(fetchPosts.rejected, (state, action) => {
                state.isLoading = false;
                state.posts = [];
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(patchPost.fulfilled, (state, action)=>{
                 if(state.posts.length > 0){
                    state.posts = state.posts?.map(post=>post.id === action.payload.id ? action.payload : post)
                 }
            })
    },
});

export default postsSlice.reducer;